import { render } from "./MainDataHead.vue?vue&type=template&id=3ec22118"
import script from "./MainDataHead.vue?vue&type=script&lang=js"
export * from "./MainDataHead.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__